import { CityPageCityFragment, CityPageFilterFragment, RegionInfoFragment } from 'utils/gqlReactTypings.generated.d';

interface UrlDetails {
  path: string[];
  filter?: CityPageFilterFragment;
}
export type PageObj = (ShallowCityPage | ZipPage | RegionInfoFragment) & UrlDetails;

export interface ShallowCityPage {
  __typename: 'ShallowCityPage';
  id: string;
  cityName: string;
  regionId: number;
  deliveryHubId?: number | null;
  stateNameShort: string;
  zipCode: string;
}

export interface ZipPage {
  __typename: 'ZipPage';
  id: string;
  cityName: string;
  regionId: number;
  deliveryHubId?: number | null;
  stateNameShort: string;
  zipCode: string;
}

// Utility function for stripping down POJOs
export const reduceShallowCityPage = (cityPage: CityPageCityFragment): ShallowCityPage => ({
  __typename: 'ShallowCityPage',
  id: cityPage.id,
  cityName: cityPage.cityName,
  regionId: cityPage.zipCodeInfo.region.id,
  stateNameShort: cityPage.stateNameShort,
  deliveryHubId: cityPage.zipCodeInfo.deliveryHubId,
  zipCode: cityPage.zipCode,
});

// TODO: Gil Note: This will need to map 1 city page to multiple zip pages
//                 (zip codes can technically be in multiple cities)
export const reduceZipPage = (cityPage: CityPageCityFragment, zipCode: string): ZipPage => ({
  __typename: 'ZipPage',
  id: cityPage.id,
  cityName: cityPage.cityName,
  regionId: cityPage.zipCodeInfo.region.id,
  deliveryHubId: cityPage.zipCodeInfo.deliveryHubId,
  stateNameShort: cityPage.stateNameShort,
  zipCode,
});

export interface Location {
  href: string;
  name: string;
}
export interface ComputedRegion extends RegionInfoFragment {
  nearbyCities?: Location[];
  nearbyZipCodes?: Location[];
}

// Type Guards
export const isShallowCityPage = (pageObj): pageObj is ShallowCityPage => pageObj.__typename === 'ShallowCityPage';
export const isZipPage = (pageObj): pageObj is ZipPage => pageObj.__typename === 'ZipPage';
export const isRegionPage = (pageObj): pageObj is RegionInfoFragment => pageObj.__typename === 'RegionInfo';
